import React, { createContext, useContext, useState, useRef } from 'react';

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [unreadCount, setUnreadCount] = useState(0);
  const lastManualUpdateRef = useRef(0);

  const updateUnreadCount = (count) => {
    setUnreadCount(count);
  };

  const decrementUnreadCount = () => {
    setUnreadCount(prev => Math.max(0, prev - 1));
    lastManualUpdateRef.current = Date.now();
  };

  const resetUnreadCount = () => {
    setUnreadCount(0);
    lastManualUpdateRef.current = Date.now();
  };

  const getLastManualUpdate = () => lastManualUpdateRef.current;

  return (
    <NotificationContext.Provider value={{ 
      unreadCount, 
      updateUnreadCount,
      decrementUnreadCount,
      resetUnreadCount,
      getLastManualUpdate
    }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
}
